import { observable, action, computed } from 'mobx';
import { SnackBarHelper } from '@lyearn-team/frontend-components';

class JoinLiveClassStore {
  @observable.ref isPopupVisible = false;

  @observable.ref contentName = '';

  @observable.ref contentId = '';

  @computed
  get joinURL() {
    const { host, protocol } = window.location;
    const { joinId } = this.store.room;
    const { contentId } = this;
    return `${protocol}//${host}/#/learner/join/${joinId}/courses/${contentId}/card`;
  }

  constructor(store) {
    this.store = store;
  }

  sync({ contentName, contentId }) {
    this.contentName = contentName;
    this.contentId = contentId;
  }

  @action
  showPopup = () => {
    this.isPopupVisible = true;
  };

  @action
  hidePopup = () => {
    this.isPopupVisible = false;
  };

  @action
  copyURL = async () => {
    await window.navigator.clipboard.writeText(this.joinURL);
    SnackBarHelper.showSnackbar({ label: 'Link copied to clipboard', status: 'success' });
  };
}

export default JoinLiveClassStore;
